import { FC } from 'react'

type PaginationProps = {
  currentPage: number
  totalPageCount: number
  handlePageClick: (page: number) => void
  handlePrevious: () => void
  handleNext: () => void
}

import { Pagination as PaginationUI } from '~/components'

export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPageCount,
  handlePageClick,
  handlePrevious,
  handleNext,
}) => {
  return (
    <div className="flex flex-col items-center gap-6">
      <p className="py-4 text-center text-sm">最大30件表示・・・・・</p>
      <PaginationUI
        currentPage={currentPage}
        handleNext={handleNext}
        handlePageClick={handlePageClick}
        handlePrevious={handlePrevious}
        totalPageCount={totalPageCount}
      />
    </div>
  )
}
